import React, { useEffect, useState } from "react";
import axios from "axios";
import { Parallax } from "react-parallax";
import LoadingPage from "./LoadingPage";
import { useDocumentMeta } from '../useDocumentMeta';

function Detail(props) {
  window.scrollTo(0, 0);
  const [detailInfo, setDetailInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = async () => {
    try {
      setError(null);
      setDetailInfo(null);
      setLoading(true);
      const response = await axios.get(
        "https://api.0u0.kr/portfolio/detail/KotteScan"
      );
      setDetailInfo(response.data.data);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    //
  }, []);
  useDocumentMeta(detailInfo?.pjDetailBigName, detailInfo?.contentHdBgColor);

  if (loading) {
    return (
      <>
        <LoadingPage />
      </>
    );
  }
  if (error) return <div>에러가 발생했습니다.</div>;
  if (!detailInfo) return null;
  if (detailInfo) {
    props.setColorData(detailInfo.contentHdBgColor);
  }

  return (
    <>
      <div
        className="detailHeader"
        style={{ backgroundColor: detailInfo.contentBgColor }}
      >
        <div className="dhTb">
          <div className="dhTbCell">
            <div className="dhDiv">
              <div className="txtBox">
                <h3>{detailInfo.pjDetailSmName}</h3>
                <h1>{detailInfo.pjDetailBigName}</h1>
              </div>
              <div className="logoBox">
                <div className="logoBoxPt">
                  <img
                    src={"https://img.0u0.kr/new_port/" + detailInfo.imgLogo}
                    alt={detailInfo.pjName + "의 로고"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="whiteBg">
        <div className="detailInfo basicWidth">
          <ul style={{ color: detailInfo.contentFontColor }}>
            <li>
              <div className="tit">카테고리</div>
              <h2>{detailInfo.tagName}</h2>
            </li>

            <li>
              <div className="tit">업무처</div>
              <h2>{detailInfo.teamName}</h2>
            </li>

            <li>
              <div className="tit">기간</div>
              <h2>{detailInfo.pjDate}</h2>
            </li>

            <li>
              <div className="tit">사용 툴/언어</div>
              <h2>{detailInfo.pjTool}</h2>
            </li>
          </ul>
        </div>
      </div>

      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <img
            src="https://img.0u0.kr/new_port/kotte_bg.jpg"
            className="bdImgBox"
            alt=""
          />
          <div className="basicDetailTitleBox">
            <h2 style={{ color: "#485250" }}>콧대스캔 어플리케이션 소개</h2>
            <div className="txtBox">
              콧대스캔은 화장품의 전성분 스캔으로 화장품성분 안전성 검사와 피부
              적합성을 검사할 수 있는 서비스 앱 입니다. 개인의 피부타입 및
              알러지 정보를 입력하여 유해성과 적합성 여부를 검사할 수 있습니다.
            </div>
          </div>
        </div>
      </div>

      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <div className="basicDetailTitleBox">
            <div className="imgGroupBox mobiCont">
              <img
                src="https://img.0u0.kr/new_port/kotte_bg2.jpg"
                className="bdImgBox"
                alt=""
              />
            </div>
            <div className="txtGroupBox kotteton">
              <h2 className="leftAlign">IONIC과 Spring Boot 활용하여 제작</h2>
              <div className="txtBox ">
                구글 클라우드 플랫폼에서 제공하는 OCR을 활용하며 화장품 전성분을
                텍스트로 변환합니다. Spring Boot로 API가 제작되었으며 DB는
                Mysql입니다.
                <div className="linkBox">
                  
                  {/* <a
                    href="https://play.google.com/store/apps/details?id=com.biopush.koTteScan&hl=ko&gl=US"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Android 다운로드
                  </a>

                  <a
                    href="https://apps.apple.com/kr/app/%EC%BD%A7%EB%8C%80%EC%8A%A4%EC%BA%94/id1528544328"
                    rel="noreferrer"
                    target="_blank"
                  >
                    iOS 다운로드
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Detail;
